var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countBar-control"},[_c('div',{staticClass:"countBar-title"},[_vm._v("当日车辆统计")]),_c('div',{staticClass:"countBar-con"},[_c('chartsBar',{key:_vm.timer,attrs:{"option":_vm.chartsLineData,"id":"chartsBar"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }